import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 640.000000 640.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,640.000000) scale(0.100000,-0.100000)">

<path d="M3003 6383 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M3133 6383 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M3373 6383 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M2865 6370 l-20 -9 20 1 c11 0 31 4 45 8 l25 8 -25 0 c-14 0 -34 -3
-45 -8z"/>
<path d="M3461 6376 c12 -10 60 -16 54 -6 -3 5 -18 10 -32 10 -15 0 -24 -2
-22 -4z"/>
<path d="M2778 6363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3600 6360 c0 -5 14 -10 32 -10 36 0 35 4 -4 14 -17 4 -28 2 -28 -4z"/>
<path d="M2678 6343 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3708 6343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2618 6333 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3748 6333 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2578 6323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3808 6323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2508 6313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2430 6303 c-40 -7 -44 -19 -5 -15 19 2 38 8 41 13 3 5 2 8 -3 8 -4
-1 -19 -4 -33 -6z"/>
<path d="M3935 6300 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0
-8 -4 5 -9z"/>
<path d="M2288 6253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4175 6230 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M2180 6220 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M1995 6155 c-27 -13 -45 -23 -40 -24 6 0 33 11 60 24 28 13 46 23 40
24 -5 0 -32 -11 -60 -24z"/>
<path d="M4399 6149 c24 -11 46 -18 48 -15 4 4 -73 36 -85 35 -4 0 13 -9 37
-20z"/>
<path d="M1880 6110 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M4510 6106 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M1820 6080 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M1655 5994 c-44 -25 -87 -52 -95 -61 -9 -10 -3 -8 15 4 17 11 53 32
80 46 46 23 97 57 85 56 -3 0 -41 -20 -85 -45z"/>
<path d="M4666 6025 c10 -8 24 -14 29 -14 6 0 1 6 -9 14 -11 8 -24 15 -30 15
-5 0 -1 -7 10 -15z"/>
<path d="M4721 5996 c2 -2 15 -9 29 -15 24 -11 24 -11 6 3 -16 13 -49 24 -35
12z"/>
<path d="M4780 5966 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M4832 5934 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M4870 5916 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M1443 5865 c-28 -19 -55 -40 -59 -47 -5 -7 14 3 41 23 28 20 59 41
70 47 11 6 15 12 10 12 -6 0 -34 -16 -62 -35z"/>
<path d="M4954 5862 c4 -7 35 -31 69 -53 72 -49 57 -30 -23 27 -30 21 -51 33
-46 26z"/>
<path d="M1277 5745 c-48 -36 -87 -68 -87 -71 0 -3 37 23 83 57 92 69 103 79
96 79 -3 0 -45 -29 -92 -65z"/>
<path d="M5125 5736 c22 -20 44 -36 49 -36 5 0 7 1 5 3 -2 2 -24 18 -49 36
l-45 33 40 -36z"/>
<path d="M1154 5648 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M5290 5601 c41 -39 84 -76 95 -83 11 -6 -5 11 -35 38 -103 93 -135
116 -60 45z"/>
<path d="M1078 5583 c-24 -21 -45 -39 -47 -40 -2 -2 -2 -5 0 -7 2 -2 26 16 52
40 59 53 54 59 -5 7z"/>
<path d="M1005 5520 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M964 5478 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M5425 5480 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M914 5428 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M877 5393 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5520 5381 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z"/>
<path d="M1260 5370 c19 -12 -8 -33 -34 -26 -16 4 -24 11 -20 18 4 7 3 8 -5 4
-9 -6 -9 -11 0 -22 7 -9 8 -14 1 -14 -6 0 -14 5 -17 10 -3 6 -14 10 -23 10
-13 0 -13 -2 4 -15 18 -14 17 -15 -17 -11 -33 4 -43 -1 -87 -42 -44 -42 -82
-92 -68 -92 3 0 13 14 21 30 9 17 20 28 25 25 6 -4 10 -1 10 4 0 16 58 64 81
68 12 2 18 -1 14 -7 -3 -5 -12 -10 -20 -10 -23 0 -89 -73 -104 -115 -16 -45
-30 -204 -19 -211 4 -3 8 -13 8 -22 0 -9 20 -42 44 -73 33 -42 40 -55 25 -52
-10 3 -16 9 -13 14 3 5 0 9 -5 9 -15 0 -14 -17 2 -27 6 -4 24 -8 40 -9 15 -1
31 -5 35 -9 4 -5 -1 -5 -10 -2 -10 3 -20 2 -23 -3 -8 -13 7 -18 30 -10 16 6
68 -5 124 -25 7 -3 219 -6 469 -6 288 -1 449 -5 439 -11 -10 -5 -185 -8 -426
-6 -225 2 -403 -1 -395 -5 7 -4 200 -7 427 -5 l413 3 -14 -28 c-10 -20 -11
-35 -5 -49 5 -12 6 -50 1 -91 -5 -38 -7 -75 -4 -81 2 -6 5 2 5 19 1 23 4 26
14 17 9 -10 13 -290 17 -1305 6 -1436 1 -1337 73 -1443 136 -203 468 -187 578
28 48 94 48 73 51 1551 3 1171 5 1389 17 1396 8 5 213 8 456 7 244 0 441 2
438 7 -4 7 50 12 90 9 10 -1 15 3 12 8 -3 6 -1 10 5 10 7 0 9 -8 5 -19 -5 -18
-3 -18 19 -8 17 8 21 13 11 15 -8 2 -15 8 -15 14 0 5 6 8 12 6 7 -3 29 10 48
29 33 31 58 44 45 23 -3 -5 -1 -10 5 -10 6 0 9 8 6 18 -7 22 19 56 37 49 10
-4 15 2 15 19 0 23 -1 23 -15 7 -12 -16 -12 -14 0 12 17 35 30 185 16 185 -5
0 -9 9 -9 19 0 11 -5 23 -10 26 -6 4 -8 10 -5 15 3 5 1 12 -5 15 -6 4 -9 14
-6 23 6 19 -29 71 -40 59 -4 -4 3 -16 16 -27 13 -11 21 -22 19 -24 -8 -9 -80
66 -76 79 4 9 -1 11 -16 8 -16 -3 -18 -2 -9 5 11 7 11 10 -3 15 -9 4 -14 3
-10 -3 9 -15 -24 -25 -38 -11 -6 6 -21 11 -34 11 -15 0 -21 4 -17 15 7 16 -32
30 -63 22 -10 -3 -3 -6 17 -7 34 -2 34 -3 -10 -11 -74 -13 -2480 -11 -2480 2
0 7 9 9 21 6 12 -3 18 -3 14 1 -4 4 -31 7 -60 7 -29 0 -49 -2 -45 -5z m1414
-160 c27 -11 66 -34 87 -51 22 -17 39 -27 39 -23 0 4 5 3 12 -4 9 -9 9 -15 -1
-24 -10 -11 -11 -9 -5 6 5 13 4 17 -4 12 -6 -3 -13 -2 -17 4 -3 5 -11 10 -17
10 -6 0 -3 -10 8 -21 18 -20 16 -19 -18 2 -20 13 -37 28 -38 33 0 5 7 3 15 -4
9 -7 18 -10 21 -7 3 3 -4 10 -15 17 -12 6 -21 8 -21 6 0 -3 -17 1 -38 8 -21 8
-57 13 -80 12 -23 -1 -42 1 -42 6 0 4 -6 6 -12 4 -41 -13 -69 -16 -64 -7 8 12
-123 -55 -145 -75 -19 -17 -49 -18 -49 -1 1 17 26 48 33 40 4 -3 7 -2 7 3 0
14 74 54 129 70 60 17 154 11 215 -16z m-80 -106 c4 -11 14 -15 33 -11 15 3
37 0 49 -5 l23 -11 -21 -16 c-20 -17 -20 -17 7 -16 16 0 30 -5 32 -11 5 -14
-25 -12 -66 5 -24 11 -29 16 -19 23 26 18 -136 1 -179 -19 -24 -11 -40 -22
-37 -26 8 -8 -35 -29 -46 -22 -18 11 -10 44 12 56 13 7 29 18 37 26 7 8 20 12
28 9 8 -3 11 -1 8 4 -3 6 -3 10 2 11 34 3 66 9 71 13 12 13 60 5 66 -10z m146
-98 c0 -11 -19 -15 -25 -6 -3 5 1 10 9 10 9 0 16 -2 16 -4z m-174 -21 c4 -10
14 -13 28 -9 27 7 78 -30 69 -51 -7 -20 -27 -19 -44 2 -13 15 -12 15 9 4 18
-9 22 -9 22 2 0 10 -10 13 -36 10 -25 -2 -33 0 -29 8 5 8 1 8 -15 -1 -12 -6
-24 -9 -28 -6 -3 3 1 6 8 6 7 0 10 3 7 6 -4 4 -13 2 -20 -5 -16 -13 -80 -4
-71 10 3 5 10 7 15 4 5 -4 9 -1 9 5 0 6 8 10 18 9 9 -1 26 -1 37 0 17 1 18 3
5 11 -10 7 -11 10 -2 10 7 0 15 -7 18 -15z m-83 -60 c-3 -17 -30 -17 -37 0 -4
13 -1 16 17 13 12 -2 21 -7 20 -13z m81 -81 c9 -23 1 -28 -21 -15 -11 6 -13
11 -5 11 7 0 10 5 7 10 -3 6 -2 10 3 10 6 0 13 -7 16 -16z"/>
<path d="M2610 5216 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
<path d="M2670 5190 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M2305 5120 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2543 5083 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M2390 5039 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M816 5320 c-32 -36 -42 -50 -33 -50 1 0 20 20 40 45 47 56 42 59 -7
5z"/>
<path d="M3912 5346 c7 -8 15 -12 17 -11 5 6 -10 25 -20 25 -5 0 -4 -6 3 -14z"/>
<path d="M5575 5320 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M5631 5253 c20 -21 51 -59 69 -85 18 -27 35 -48 37 -48 5 0 -18 42
-31 57 -6 6 -29 34 -51 62 -22 27 -44 50 -50 51 -5 0 7 -17 26 -37z"/>
<path d="M4096 5210 c3 -14 11 -32 16 -40 6 -10 7 -7 2 10 -3 14 -11 32 -16
40 -6 10 -7 7 -2 -10z"/>
<path d="M675 5150 c-10 -11 -16 -22 -13 -25 3 -3 13 6 22 20 20 30 16 32 -9
5z"/>
<path d="M986 5157 c3 -9 1 -24 -6 -32 -7 -9 -11 -18 -8 -20 3 -3 11 6 18 20
11 20 11 28 1 38 -10 9 -11 8 -5 -6z"/>
<path d="M5756 5097 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M4132 5080 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M610 5065 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z"/>
<path d="M976 5043 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5840 4978 c29 -43 54 -78 56 -78 7 0 -66 113 -87 135 -11 11 3 -15
31 -57z"/>
<path d="M4132 5010 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M555 4989 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M986 4952 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M513 4923 c-9 -16 -22 -35 -27 -43 -9 -12 -8 -13 4 -3 17 13 54 73
46 73 -3 0 -13 -12 -23 -27z"/>
<path d="M1008 4914 c-3 -5 3 -22 13 -39 22 -36 24 -30 5 15 -7 18 -16 29 -18
24z"/>
<path d="M4075 4880 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5930 4840 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
<path d="M4010 4819 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1170 4770 c14 -4 34 -8 45 -8 16 0 15 2 -5 8 -14 4 -34 8 -45 8 -16
0 -15 -2 5 -8z"/>
<path d="M404 4738 c-9 -18 -24 -44 -32 -58 -14 -24 -13 -24 3 -5 19 23 58 95
50 95 -2 0 -12 -15 -21 -32z"/>
<path d="M3888 4753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2927 4738 c-7 -4 179 -6 413 -6 234 1 376 3 315 5 -261 7 -718 7
-728 1z"/>
<path d="M5990 4730 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
<path d="M3788 4733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2932 4700 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6027 4665 c9 -19 18 -33 21 -31 4 5 -26 66 -33 66 -3 0 3 -16 12
-35z"/>
<path d="M2934 4570 c0 -52 1 -74 3 -47 2 26 2 68 0 95 -2 26 -3 4 -3 -48z"/>
<path d="M6056 4607 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M322 4581 c-6 -17 -9 -31 -6 -31 7 0 25 52 20 57 -2 2 -8 -10 -14
-26z"/>
<path d="M6091 4540 c0 -8 4 -22 9 -30 12 -18 12 -2 0 25 -6 13 -9 15 -9 5z"/>
<path d="M286 4505 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M251 4424 c-6 -15 -9 -29 -7 -32 3 -2 10 8 16 23 14 36 7 43 -9 9z"/>
<path d="M6144 4412 c9 -23 20 -50 26 -60 10 -15 11 -15 5 3 -23 67 -29 81
-37 90 -5 5 -2 -9 6 -33z"/>
<path d="M2090 4416 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M3768 4413 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3970 4403 c14 -3 27 -9 30 -13 3 -5 13 -3 22 4 13 10 8 12 -31 12
-25 1 -35 -1 -21 -3z"/>
<path d="M2145 3240 c0 -641 1 -903 2 -583 2 321 2 845 0 1165 -1 321 -2 59
-2 -582z"/>
<path d="M4070 4396 c0 -9 30 -14 35 -6 4 6 -3 10 -14 10 -12 0 -21 -2 -21 -4z"/>
<path d="M4125 4380 c7 -12 45 -14 45 -2 0 4 -11 9 -26 10 -14 1 -23 -2 -19
-8z"/>
<path d="M4213 4364 c26 -9 44 -10 60 -3 19 8 19 9 -6 4 -16 -3 -27 -2 -24 2
3 4 -11 9 -32 10 l-36 1 38 -14z"/>
<path d="M2101 4354 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4155 4350 c-7 -11 22 -26 32 -16 4 3 -1 6 -11 6 -9 0 -14 5 -11 10
3 6 4 10 1 10 -3 0 -8 -5 -11 -10z"/>
<path d="M4285 4351 c-17 -7 -16 -9 13 -16 18 -4 36 -4 39 -1 4 3 -5 6 -18 7
-22 0 -23 1 -4 9 26 11 -2 12 -30 1z"/>
<path d="M4228 4333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4443 4306 c25 -15 34 -26 25 -29 -8 -4 -9 -6 -1 -6 6 -1 15 3 18 9
6 10 -51 50 -70 50 -5 -1 7 -11 28 -24z"/>
<path d="M186 4253 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M4545 4260 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M4423 4253 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4590 4240 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4646 4216 c5 -12 2 -15 -10 -10 -26 10 -18 -10 9 -23 14 -6 25 -7
25 -2 0 5 -6 9 -12 9 -10 0 -10 2 0 9 10 6 10 10 -3 21 -13 11 -14 10 -9 -4z"/>
<path d="M4715 4166 c17 -7 36 -21 44 -30 13 -15 13 -19 0 -27 -8 -5 -9 -9 -4
-9 6 0 16 4 24 9 13 8 13 12 1 26 -16 19 -64 45 -82 45 -7 -1 1 -7 17 -14z"/>
<path d="M6236 4145 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M146 4135 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2 2
-6 -3 -10 -12z"/>
<path d="M4730 4130 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4826 4088 c16 -21 32 -38 37 -38 4 0 7 -6 7 -14 0 -8 5 -18 12 -22
7 -4 8 -3 4 4 -11 19 9 14 27 -6 10 -10 14 -22 10 -25 -3 -4 -1 -7 5 -7 22 0
12 17 -36 61 -91 82 -99 88 -66 47z"/>
<path d="M121 4034 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6286 3977 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M101 3973 c0 -6 -4 -20 -7 -30 -5 -14 -4 -15 5 -7 7 7 11 20 8 30 -3
11 -5 14 -6 7z"/>
<path d="M4951 3971 c-1 -8 -8 -11 -21 -8 -24 6 -27 -8 -3 -17 20 -8 37 7 30
26 -4 11 -6 11 -6 -1z"/>
<path d="M4975 3951 c4 -8 2 -17 -6 -22 -9 -6 -10 -9 -2 -9 19 0 27 21 13 33
-10 9 -11 9 -5 -2z"/>
<path d="M6301 3934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5010 3891 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M5040 3861 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M5040 3821 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M62 3775 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5084 3789 c-3 -6 -2 -15 3 -20 5 -5 9 -1 9 11 0 23 -2 24 -12 9z"/>
<path d="M5040 3781 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M6332 3770 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5120 3744 c0 -5 7 -18 15 -28 8 -11 15 -16 15 -10 0 5 -7 18 -15 28
-8 11 -15 16 -15 10z"/>
<path d="M6342 3720 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M51 3714 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3180 3671 c0 -6 -7 -11 -15 -11 -8 0 -15 -5 -15 -11 0 -5 5 -7 11
-3 6 3 88 7 183 7 l171 1 -154 3 c-93 2 -160 8 -168 14 -9 8 -13 8 -13 0z"/>
<path d="M6350 3652 c0 -18 5 -32 10 -32 6 0 8 11 4 28 -10 39 -14 40 -14 4z"/>
<path d="M3798 3663 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5160 3667 c0 -5 5 -17 10 -28 8 -13 7 -19 0 -19 -6 0 -8 -5 -4 -11
4 -8 9 -7 15 2 7 12 9 12 9 0 0 -8 2 -12 6 -9 3 3 -4 21 -15 39 -12 19 -21 30
-21 26z"/>
<path d="M3538 3653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3598 3648 c4 -4 30 -3 57 2 l50 8 -57 -1 c-31 -1 -54 -5 -50 -9z"/>
<path d="M3735 3645 c-16 -8 -23 -14 -14 -15 8 0 24 7 35 15 23 18 18 18 -21
0z"/>
<path d="M5131 3644 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3788 3643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3780 3620 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M3141 3558 c1 -55 5 -50 11 15 2 20 0 37 -4 37 -4 0 -7 -24 -7 -52z"/>
<path d="M3872 3595 c18 -13 128 -62 128 -57 0 4 -14 13 -30 21 -29 12 -30 14
-13 28 17 13 16 13 -4 4 -26 -13 -36 -14 -30 -3 3 4 -8 7 -24 8 -16 1 -28 0
-27 -1z"/>
<path d="M6363 3550 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3970 3576 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M5223 3538 c2 -15 6 -30 10 -34 10 -10 8 17 -3 41 -8 17 -9 16 -7 -7z"/>
<path d="M25 3510 c-4 -23 -5 -44 -2 -46 3 -3 8 13 12 36 4 23 5 44 2 46 -3 3
-8 -13 -12 -36z"/>
<path d="M4080 3470 c19 -20 39 -34 43 -32 10 5 -22 42 -36 42 -6 0 -18 6 -26
13 -9 6 -1 -4 19 -23z"/>
<path d="M4121 3484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6372 3465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5252 3455 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M4146 3426 c6 -15 4 -17 -6 -11 -9 6 -11 4 -5 -4 5 -9 10 -10 18 -2
8 8 7 14 -2 24 -10 10 -11 8 -5 -7z"/>
<path d="M6383 3350 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M12 3355 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5281 3375 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z"/>
<path d="M4205 3349 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5293 3255 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M4222 3260 c14 -22 24 -19 15 5 -4 8 -11 15 -17 15 -6 0 -6 -7 2 -20z"/>
<path d="M6382 3260 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5311 3254 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M13 3160 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M4248 3173 c6 -33 17 -36 17 -4 0 15 -5 28 -11 28 -6 0 -9 -11 -6
-24z"/>
<path d="M4281 3164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5320 3171 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M6382 3145 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M4296 3117 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M5335 3120 c-3 -5 -1 -18 4 -27 9 -15 10 -14 9 10 -3 30 -4 32 -13
17z"/>
<path d="M4276 3095 c8 -37 14 -45 14 -19 0 10 -5 26 -10 34 -8 11 -9 7 -4
-15z"/>
<path d="M6383 3050 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M12 3010 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4292 2980 c0 -19 4 -46 9 -60 8 -22 8 -21 4 8 -3 22 -1 31 6 26 8
-4 8 -1 1 12 -5 11 -12 26 -15 34 -3 8 -5 -1 -5 -20z"/>
<path d="M5361 2994 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5368 2943 c5 -21 7 -23 10 -9 2 10 0 22 -6 28 -6 6 -7 0 -4 -19z"/>
<path d="M6373 2925 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M21 2909 c0 -13 4 -33 9 -44 7 -14 8 -8 3 20 -7 46 -13 59 -12 24z"/>
<path d="M6362 2825 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M30 2798 c0 -16 5 -28 10 -28 13 0 13 20 0 40 -8 12 -10 9 -10 -12z"/>
<path d="M6350 2761 c0 -25 6 -27 13 -6 4 8 2 17 -3 20 -6 4 -10 -3 -10 -14z"/>
<path d="M4314 2640 c0 -69 1 -97 3 -62 2 34 2 90 0 125 -2 34 -3 6 -3 -63z"/>
<path d="M51 2684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6342 2680 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6332 2630 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M72 2570 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6300 2479 c0 -11 -5 -30 -11 -42 -10 -21 -10 -21 5 -3 15 18 22 66
11 66 -3 0 -5 -9 -5 -21z"/>
<path d="M4312 2460 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M101 2434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6266 2345 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2
2 -6 -3 -10 -12z"/>
<path d="M131 2324 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5366 2294 c-4 -14 -5 -28 -3 -31 3 -2 8 8 11 23 4 14 5 28 3 31 -3
2 -8 -8 -11 -23z"/>
<path d="M4301 2294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M140 2285 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5
8 -10 11 -10 5z"/>
<path d="M4290 2230 c0 -19 3 -21 12 -12 9 9 9 15 0 24 -9 9 -12 7 -12 -12z"/>
<path d="M5362 2215 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M160 2223 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23 -5
3 -10 3 -10 -2z"/>
<path d="M6219 2193 c-5 -14 -8 -30 -6 -36 1 -5 8 7 14 27 13 42 7 49 -8 9z"/>
<path d="M4282 2160 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M181 2164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5333 2110 c-5 -22 -7 -37 -2 -35 9 6 23 64 17 70 -2 3 -9 -13 -15
-35z"/>
<path d="M6196 2125 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M4267 2101 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
<path d="M210 2085 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5
8 -10 11 -10 5z"/>
<path d="M2096 2018 c-4 -37 -2 -66 4 -72 7 -7 10 14 10 62 0 40 -2 72 -4 72
-2 0 -6 -28 -10 -62z"/>
<path d="M4281 2043 c-1 -6 -4 -20 -7 -30 -5 -17 -5 -17 6 0 6 10 9 23 6 30
-3 9 -5 9 -5 0z"/>
<path d="M4300 2025 c0 -14 2 -25 4 -25 2 0 6 11 8 25 3 14 1 25 -3 25 -5 0
-9 -11 -9 -25z"/>
<path d="M4246 2025 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M6153 2015 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M2136 2003 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5282 2000 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M241 2005 c0 -5 6 -21 14 -35 8 -14 14 -20 14 -15 0 6 -6 21 -14 35
-8 14 -14 21 -14 15z"/>
<path d="M2951 1994 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6135 1969 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5291 1954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2140 1930 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2103 1855 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
<path d="M291 1890 c14 -31 19 -36 19 -24 0 6 -7 19 -16 30 -14 18 -14 18 -3
-6z"/>
<path d="M2937 1881 c-4 -20 -3 -39 3 -45 14 -14 21 14 12 49 l-8 30 -7 -34z
m10 -33 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M4190 1887 c0 -7 7 -22 15 -33 13 -17 14 -16 4 14 -11 33 -19 41 -19
19z"/>
<path d="M4137 1815 c-21 -30 -34 -55 -29 -55 4 0 21 20 36 45 16 24 32 42 37
39 5 -3 6 2 3 10 -3 9 -7 16 -8 16 0 -1 -18 -25 -39 -55z"/>
<path d="M5291 1854 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M316 1837 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6075 1829 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M2907 1794 c-10 -19 -12 -32 -7 -29 12 7 33 55 27 61 -2 2 -11 -12
-20 -32z"/>
<path d="M2166 1804 c-9 -24 -6 -41 4 -19 l9 20 1 -20 c2 -11 2 -23 1 -27 0
-5 3 -7 8 -5 5 1 17 -7 26 -18 15 -18 16 -18 11 -2 -3 10 -6 23 -6 28 0 6 -4
7 -10 4 -5 -3 -10 1 -10 10 0 9 -6 23 -14 30 -12 12 -15 12 -20 -1z"/>
<path d="M5225 1790 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5253 1785 c-9 -24 1 -27 15 -5 8 13 8 20 2 20 -6 0 -13 -7 -17 -15z"/>
<path d="M6027 1735 c-9 -19 -15 -35 -12 -35 7 0 37 61 33 66 -3 2 -12 -12
-21 -31z"/>
<path d="M2102 1695 c-5 -98 -2 -819 3 -824 3 -2 6 -2 8 0 1 2 0 202 -3 444
-3 242 -7 413 -8 380z"/>
<path d="M3139 1713 c-3 -25 0 -44 6 -47 7 -2 9 10 7 33 -5 56 -9 60 -13 14z"/>
<path d="M4054 1729 c-3 -6 -1 -16 6 -22 10 -9 12 -8 7 5 -3 9 -1 19 6 22 9 3
9 5 0 5 -6 1 -15 -4 -19 -10z"/>
<path d="M376 1717 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M2185 1720 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5232 1708 c-7 -7 -12 -19 -12 -27 0 -14 -1 -14 -10 -1 -5 8 -10 11
-10 5 0 -32 17 -32 32 0 17 39 17 40 0 23z"/>
<path d="M2252 1705 c4 -4 3 -14 -3 -22 -13 -15 9 -47 46 -65 11 -6 5 4 -13
21 -27 25 -31 35 -22 45 8 11 8 16 -2 22 -7 4 -10 4 -6 -1z"/>
<path d="M3995 1690 c-16 -11 -49 -25 -73 -31 -23 -7 -41 -13 -39 -16 10 -9
94 20 122 43 36 29 31 31 -10 4z"/>
<path d="M2846 1688 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"/>
<path d="M405 1660 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21
30 -2 0 2 -13 11 -30z"/>
<path d="M5990 1670 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M2290 1658 c14 -14 31 -25 39 -25 15 0 -8 20 -44 39 -16 8 -14 5 5
-14z"/>
<path d="M2805 1660 c-18 -20 -18 -21 5 -12 13 5 26 14 28 20 6 19 -13 14 -33
-8z"/>
<path d="M2834 1641 c-5 -5 -18 -11 -29 -14 -15 -4 -14 -5 7 -6 15 0 30 4 33
10 9 14 1 21 -11 10z"/>
<path d="M3800 1624 l-45 -13 46 2 c26 1 45 5 43 9 -2 3 2 9 8 11 24 10 -7 5
-52 -9z"/>
<path d="M3948 1633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2345 1620 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 11 -9 22 0 14
11 18 19 10 19 -3 0 -8 -5 -11 -10z"/>
<path d="M2740 1620 c-8 -4 -26 -13 -40 -18 -22 -10 -21 -10 10 -5 19 3 42 12
50 19 16 15 4 18 -20 4z"/>
<path d="M3885 1620 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M3140 1616 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M3978 1613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3268 1603 c34 -2 88 -2 120 0 31 2 3 3 -63 3 -66 0 -92 -1 -57 -3z"/>
<path d="M3615 1601 c22 -4 46 -10 53 -14 6 -5 12 -4 12 1 0 14 -27 22 -68 21
l-37 -2 40 -6z"/>
<path d="M450 1580 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
<path d="M5166 1575 c-9 -14 -13 -25 -8 -25 5 0 14 11 20 25 6 14 10 25 8 25
-2 0 -11 -11 -20 -25z"/>
<path d="M2588 1573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2638 1573 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5888 1494 c-26 -41 -45 -74 -43 -74 7 0 97 141 93 145 -2 2 -25 -30
-50 -71z"/>
<path d="M2438 1553 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2600 1556 c0 -2 11 -6 25 -8 13 -3 22 -1 19 3 -5 9 -44 13 -44 5z"/>
<path d="M5133 1540 c1 -15 -3 -24 -10 -23 -7 2 -10 -4 -6 -13 5 -12 8 -12 20
5 10 15 11 26 4 38 -9 16 -10 15 -8 -7z"/>
<path d="M2455 1530 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2488 1533 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2690 1530 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M495 1510 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M5080 1499 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5097 1473 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5056 1444 c-4 -16 -2 -32 4 -38 8 -8 9 -6 4 7 -3 10 -3 17 2 15 10
-3 14 5 14 27 0 25 -17 17 -24 -11z"/>
<path d="M580 1380 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26
30 -3 0 4 -13 16 -30z"/>
<path d="M5815 1384 c-9 -15 -12 -23 -6 -20 11 7 35 46 28 46 -3 0 -12 -12
-22 -26z"/>
<path d="M4980 1352 c0 -7 -3 -11 -8 -8 -4 2 -8 -11 -8 -29 0 -19 3 -32 7 -29
5 2 6 11 2 19 -3 11 -1 13 10 9 22 -8 32 16 13 34 -11 11 -16 12 -16 4z m20
-16 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z"/>
<path d="M5768 1320 c-22 -39 -15 -39 12 0 12 17 18 30 13 30 -4 0 -16 -14
-25 -30z"/>
<path d="M625 1316 c10 -14 19 -26 22 -26 7 0 -17 39 -28 46 -6 3 -3 -5 6 -20z"/>
<path d="M660 1275 c0 -4 9 -18 20 -32 11 -14 20 -22 20 -18 0 4 -9 18 -20 32
-11 14 -20 22 -20 18z"/>
<path d="M4885 1270 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M4919 1262 c-21 -24 -31 -42 -25 -42 6 0 56 49 56 55 0 11 -17 4 -31
-13z"/>
<path d="M5656 1172 c-22 -27 -24 -32 -7 -17 20 17 47 55 39 55 -2 0 -16 -17
-32 -38z"/>
<path d="M4809 1188 c-1 -2 -3 -13 -4 -25 -2 -18 1 -21 15 -13 9 5 23 17 31
27 12 16 11 16 -9 -1 -12 -11 -25 -16 -29 -12 -4 4 -1 11 7 16 10 7 11 10 3
10 -7 0 -14 -1 -14 -2z"/>
<path d="M750 1155 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25 -28
25 -3 0 5 -11 18 -25z"/>
<path d="M5572 1080 c-56 -65 -49 -64 12 0 26 28 44 50 39 50 -4 -1 -27 -23
-51 -50z"/>
<path d="M791 1113 c5 -13 99 -117 99 -109 0 3 -23 31 -51 63 -29 31 -50 52
-48 46z"/>
<path d="M4675 1090 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4605 1020 c-33 -16 -54 -29 -47 -30 14 0 112 48 112 55 0 6 6 8 -65
-25z"/>
<path d="M915 970 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M4483 972 c1 -12 6 -18 15 -15 7 3 10 9 5 12 -4 3 -11 10 -15 15 -4
4 -6 -1 -5 -12z"/>
<path d="M4520 979 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5474 968 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M4285 950 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23 -10z"/>
<path d="M4338 953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M974 912 c17 -18 33 -32 38 -32 9 0 -17 27 -47 50 -11 8 -7 0 9 -18z"/>
<path d="M4355 930 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M5411 909 c-18 -16 -31 -32 -29 -34 2 -3 20 11 38 30 42 43 36 46 -9
4z"/>
<path d="M4230 910 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M4266 901 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M4200 890 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4148 873 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4023 863 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4098 863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5315 823 c-27 -25 -41 -41 -30 -35 19 10 94 82 84 82 -2 -1 -26 -22
-54 -47z"/>
<path d="M3768 853 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3836 853 c-4 -5 -393 -10 -864 -13 l-857 -5 885 -1 c487 -1 874 1
860 4 -23 4 -24 5 -5 13 14 5 16 8 4 8 -9 1 -19 -2 -23 -6z"/>
<path d="M3920 850 c-34 -7 -34 -7 -5 -8 17 0 44 4 60 8 27 7 27 8 5 8 -14 -1
-41 -4 -60 -8z"/>
<path d="M1087 810 c18 -19 34 -32 36 -29 2 2 -12 17 -32 33 l-36 30 32 -34z"/>
<path d="M5234 748 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M1160 751 c0 -5 12 -17 28 -26 l27 -18 -24 27 c-26 28 -31 31 -31 17z"/>
<path d="M5170 699 c-35 -31 -35 -31 -3 -9 18 11 35 25 38 30 10 16 2 11 -35
-21z"/>
<path d="M1234 687 c10 -7 31 -22 46 -34 15 -13 31 -23 35 -23 4 0 -12 16 -36
35 -24 19 -48 35 -54 34 -5 0 -2 -6 9 -12z"/>
<path d="M5104 649 c-19 -22 -19 -22 4 -8 12 8 22 17 22 21 0 12 -6 9 -26 -13z"/>
<path d="M1397 569 c6 -8 26 -22 45 -32 l33 -19 -25 21 c-14 12 -34 27 -45 33
-17 9 -18 9 -8 -3z"/>
<path d="M4957 546 c-55 -39 -76 -59 -32 -31 62 38 99 65 90 64 -6 0 -32 -15
-58 -33z"/>
<path d="M1510 496 c0 -2 16 -13 36 -25 19 -12 32 -16 29 -11 -7 11 -65 43
-65 36z"/>
<path d="M4839 469 l-24 -20 30 17 c39 24 40 24 28 24 -6 0 -21 -9 -34 -21z"/>
<path d="M1597 439 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M4758 424 c-27 -13 -48 -27 -48 -29 0 -3 23 6 50 20 28 14 50 28 50
30 0 7 1 7 -52 -21z"/>
<path d="M1630 426 c0 -3 14 -12 30 -21 17 -9 30 -13 30 -11 0 3 -13 12 -30
21 -16 9 -30 13 -30 11z"/>
<path d="M1700 385 c0 -7 61 -37 66 -33 2 3 -12 12 -31 21 -19 9 -35 15 -35
12z"/>
<path d="M4650 365 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16 0z"/>
<path d="M1780 346 c0 -3 14 -12 30 -21 17 -9 30 -13 30 -11 0 3 -13 12 -30
21 -16 9 -30 13 -30 11z"/>
<path d="M4590 335 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16 0z"/>
<path d="M1900 285 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35 14
-5 0 1 -6 15 -14z"/>
<path d="M4433 266 c-71 -29 -81 -43 -13 -16 30 12 59 26 65 31 12 12 9 11
-52 -15z"/>
<path d="M1951 266 c2 -2 15 -9 29 -15 24 -11 24 -11 6 3 -16 13 -49 24 -35
12z"/>
<path d="M2030 230 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M4270 200 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0
-17 -5 -25 -10z"/>
<path d="M4200 175 c-33 -19 -21 -19 21 0 19 8 27 14 19 14 -8 0 -26 -6 -40
-14z"/>
<path d="M4045 130 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2367 119 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2425 105 c17 -8 39 -14 50 -14 11 0 0 7 -25 15 -56 17 -64 17 -25
-1z"/>
<path d="M3918 93 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3818 73 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2608 63 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3753 63 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M2678 53 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3708 53 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2745 40 c27 -12 35 -12 35 0 0 6 -12 10 -27 9 -25 0 -26 -1 -8 -9z"/>
<path d="M3620 40 c0 -13 11 -13 30 0 12 8 11 10 -7 10 -13 0 -23 -4 -23 -10z"/>
<path d="M2813 33 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M3543 33 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M2918 23 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3468 23 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M3018 13 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M3188 13 c39 -2 105 -2 145 0 39 1 7 3 -73 3 -80 0 -112 -2 -72 -3z"/>
</g>
</svg>








    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
